module.exports = "/images/sub-extended-pages.png?8d2f4525097460f73925d572dbfd7586";